module.exports = __webpack_public_path__ + "img/chara_line_5.0e8f3288.png";